import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/settings/')({
  head: () => noIndexRouteHead('settings', 'en'),
  component: SettingsPage,
})
